import LocalStorage from 'services/LocalStorage'

export const rules = {
  showInitTest: () =>
    LocalStorage.getSimple('refresh') && LocalStorage.getSimple('ud'),
}
